<template>
  <div id="cs">
    <div class="columns is-fullheight">
      <div class="column is-2 colorsidebar ">
        <div id="sidebar">
          <template>
            <b-menu class="is-sidebar-menu">
              <span class="image is-pulled-centered" >
                 <!-- <h1 style="font-weight:bold">GERAKAN PANDAI <span style="font-weight:bold;color:blue">NEWS</span></h1> -->
                  <img src="../assets/bebrasIndo.png" style="height:80px">
                  </span>
            <!-- <p>LOGO GERAKAN PANDAI</p> -->
            <b-menu-list label="Menu">
              <!-- <b-menu-item icon="view-dashboard" label="Dashboard"></b-menu-item> -->
              <b-menu-item
                icon="bank"
                label="Data Biro"
                tag="router-link"
                :to="{ name: 'BerandaBiro' }">
              </b-menu-item>
              <!-- <b-menu-item
                icon="file-powerpoint-box"
                label="Assign Paket"
                tag="router-link"
                :to="{ name: 'BerandaPaket' }">
              </b-menu-item> -->
              <b-menu-item
                icon="book-multiple"
                label="Import All"
                tag="router-link"
                :to="{ name: 'BerandaImport' }">
              </b-menu-item>
                <b-menu-item
                icon="chart-areaspline"
                label="Reporting"
                tag="router-link"
                :to="{ name: 'BerandaReport' }">
              </b-menu-item>
              <!-- <b-menu-item
                icon="newspaper"
                label="Blog"
                tag="router-link"
                :to="{ name: 'BerandaBlog' }">
              </b-menu-item> -->
              <b-menu-item
                icon="newspaper"
                label="Blog & Podcast"
                tag="router-link"
                :to="{ name: 'NewBlog' }">
              </b-menu-item>
              <!-- <b-menu-item
                icon="account-switch"
                label="Event"
                tag="router-link"
                :to="{ name: 'BerandaPelatihanAdmin' }">
              </b-menu-item> -->
              <!-- <b-menu-item
                icon="account-switch"
                label="List Data"
                tag="router-link"
                :to="{ name: 'List Data' }">
              </b-menu-item>
               -->
            </b-menu-list>
            <b-menu-list label="Actions">
              <b-menu-item
                icon="logout"
                label="Logout"
                @click="confirmLogout()"
              ></b-menu-item>
            </b-menu-list>
          </b-menu>
          </template>
        </div>
      </div>

      <div class="column has-background-white-ter is-fullheight" style="overflow-y: scroll">
        <div id="navbar">
          <b-navbar class="has-background-white-ter nav-padding">
            <template slot="end">
              <b-dropdown position="is-bottom-left" append-to-body>
                <a class="navbar-item" slot="trigger" role="button">
                  <span>{{ activeUser.email }}</span>
                  <b-icon icon="menu-down"></b-icon>
                </a>

                <b-dropdown-item custom aria-role="menuitem">
                  Logged as <b>{{ activeUser.role }}</b>
                </b-dropdown-item>
                <!-- <hr class="dropdown-divider">
                <b-dropdown-item value="settings">
                  <b-icon icon="cogs"></b-icon>
                  Settings
                </b-dropdown-item>
                <b-dropdown-item value="logout" aria-role="menuitem" @click="confirmLogout">
                  <b-icon icon="logout"></b-icon>
                  Logout
                </b-dropdown-item> -->
              </b-dropdown>
            </template>
          </b-navbar>
        </div>
        <div id="content">
          <div>
            <auto-logout></auto-logout>
            <router-view activeUser="activeUser" />
            
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AutoLogout from './AutoLogout.vue'
export default {
  components: { AutoLogout },
  data() {
   

    return {
     
      activeUser: Object,
      isActive: true,
      activeBiro: Object,
      isLoginBiro: false,
    }
  },
  methods: {
    userLogout(){
      this.$session.destroy()
      this.$router.push('/')
    },
    confirmLogout(){
      this.$buefy.dialog.confirm({
        title:'Logout',
        message:'Kamu yakin ingin ke keluar dari sistem ?',
        confirmText:'Ya',
        cancelText:'Batal',
        type:'is-danger',
        hasIcon:true,
        onConfirm:() => this.userLogout()
      })
    }
  },
  mounted(){
    if(this.$session.exists()){
      this.activeUser = this.$session.get('user')
    }
  }
}
</script>

<style scoped>
.colorsidebar {
  background-color: #E5E5E5;
}

.is-fullheight.columns {
    height: calc(100vh - ( 0rem - .75rem ) );
}

/* .title-nama-data {
  margin: 20px 10px;
} */

.is-sidebar-menu {
  margin: 10px 0 0 10px;
}
</style>